
<template>
  <!--钥匙申请-->
  <div>
    <x-tabula
      :dataSource="dataSource"
      rowKey="apply_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_t" slot-scope="{row}">
        <p v-for="(item, index) of row.room_address" :key="index">{{item}}</p>
      </template>
      <template slot="opt_o" slot-scope="{row}">
        <span v-for="(item, index) of rowOptList" :key="index">
          <template v-if="row.status === 0 && item.text=== '审核'">
            <a-button @click="toAudit(row)" type="link">{{item.text}}</a-button>
          </template>

          <template v-if="row.status !== 0 && item.text=== '详情'">
            <a-button @click="toAudit(row)" type="link">{{item.text}}</a-button>
          </template>
        </span>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'keyApply',
  data () {
    return {
      searchList: [
        { props: ['community_id'], placeholder: '小区名称', options: [], inputType: 'select' },
        { props: ['mobile_phone'], placeholder: '手机号', options: [], inputType: 'input' },
        { props: ['status'], placeholder: '审核状态', options: [], inputType: 'select' },
        { props: ['area_id'], placeholder: '省市', options: [], inputType: 'cascader', changeOnSelect: true },
        { props: ['property_id'], placeholder: '物业', options: [], inputType: 'select' },
        { props: ['apply_date'], placeholder: ['申请时间', '申请时间'], options: [], inputType: 'datePick' },
        { props: ['check_date'], placeholder: ['审核时间', '审核时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [],
      rowOptList: [
        {text: '审核', key: 'audit'},
        {text: '详情', key: 'detail'}
      ],
      columns: [
        { title: 'ID', dataIndex: 'apply_id', align: 'left', width: '' },
        { title: '手机号', dataIndex: 'mobile', align: 'left', width: '' },
        { title: '房间', dataIndex: 'room_address', align: 'left', width: '', scopedSlots: {customRender: 'action_t'} },
        { title: '申请时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '审核状态', dataIndex: 'status_desc', align: 'left', width: '' },
        { title: '审核人', dataIndex: 'check_user', align: 'left', width: '' },
        { title: '审核时间', dataIndex: 'check_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action_o'} }
      ],
      dataSource: [],
      searchParams: {
        community_id: '',
        mobile_phone: '',
        status: '',
        area_id: [],
        property_id: '',
        apply_date: [],
        check_date: []
      },
      listApi: {
        url: '/key_apply',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {}
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      this.communitySelect(0, 'searchList', 1);
      this.propertySelect(4);
      this.deviceManageSelect([{index: 2, key: 'check_status'}]);
      this.regionSelect(3);
    },
    /* 进入审核页面 */
    toAudit (row) {
      this.$router.push({
        name: 'keyApplyDetail',
        query: {
          id: row.apply_id,
          status: `${row.status}`,
          title: row.status === 0 ? '审核申请钥匙' : '钥匙申请详情'
        }
      });
    },
    resHandle (res) {
      console.log('处理list返回数据: ');
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/device/keyApply/keyApply.vue